export const BASE_URL = process.env.REACT_APP_API_URL;
export const API_URL = BASE_URL + "api/";
